'use client';

import { type ReactNode } from 'react';

import { AudioPlayerProvider } from '@/libs';

export const AudioProviderWrapper = ({ children }: { children: ReactNode }) => {
  return <AudioPlayerProvider>{children}</AudioPlayerProvider>;
};
